import React, { Component } from "react";
import "../../Page/Dashboard/index.css";
import "../index.css";
import "./index.css";
import TopMenu from "../Layout/TopMenu";
import MenuDesktop from "../Layout/MenuDesktop";
import { MDBRow, MDBCol } from "mdbreact";
import { IoSearch } from "react-icons/io5";
import { NavLink, withRouter } from "react-router-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiArrowRightSLine,
} from "react-icons/ri";
import NavBar from "../Layout/NavBar";
import mixpanel from "mixpanel-browser";
import { HiLightningBolt, HiSortAscending } from "react-icons/hi";

import { firebase } from "../../../firebase/config";

import { TiTick } from "react-icons/ti";
import VisibilitySensor from "react-visibility-sensor";
import Scroll from "react-scroll";
const scroll = Scroll.animateScroll;

function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

let x1 = randomIntFromInterval(10, 200);
let y1 = randomIntFromInterval(10, x1);
let x2 = randomIntFromInterval(10, 200);
let y2 = randomIntFromInterval(10, x2);
let x3 = randomIntFromInterval(10, 200);
let y3 = randomIntFromInterval(10, x3);
let x4 = randomIntFromInterval(10, 200);
let y4 = randomIntFromInterval(10, x4);
let x5 = randomIntFromInterval(10, 200);
let y5 = randomIntFromInterval(10, x5);
let x6 = randomIntFromInterval(10, 200);
let y6 = randomIntFromInterval(10, x6);
let x7 = randomIntFromInterval(10, 200);
let y7 = randomIntFromInterval(10, x7);
let x8 = randomIntFromInterval(10, 200);
let y8 = randomIntFromInterval(10, x8);

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      querySellers: [],
      Email: "",
      Password: "",
      error: "",
      price: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmitEmail = this.onSubmitEmail.bind(this);
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onSubmitEmail = (event) => {
    if (!this.state.Email || !this.state.Password) {
      return this.setState({ error: "Missing email or password" });
    } else {
      firebase
        .auth()
        .signInWithEmailAndPassword(
          this.state.Email.trim(),
          this.state.Password.trim()
        )
        .then(() => {
          this.setState({ error: null });
          window.location = "";
        })
        .catch((error) => {
          this.setState({ error: error.message });
        });
    }

    event.preventDefault();
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    this.setState({
      price: params.get("price"),
    });
  }

  render() {
    console.log(this.props.version);
    return (
      <>
        <MDBCol
          style={{
            width: "105vw",
            overflowX: "hidden",
            paddingBottom: 0,
            height: "100vh",
          }}
          className="HeroSection"
          size="12"
        >
          <MDBRow style={{ marginTop: 0 }}>
            <MDBCol size="12">
              <NavLink to="/" exact onClick={() => window.scrollTo(0, 0)}>
                <p
                  style={{
                    fontFamily: "Grifter",
                    color: "white",
                    fontSize: 23,
                    fontWeight: "900",
                    marginTop: 32,
                    display: "inline-block",
                    marginLeft: 85,
                  }}
                >
                  <img
                    style={{ height: 30, marginTop: -5.6 }}
                    src={require("./Logo.png")}
                  />{" "}
                  YouDub
                </p>
              </NavLink>
            </MDBCol>

            <div
              className="d-flex justify-content-center"
              style={{ width: "100vw" }}
            >
              <MDBRow style={{ marginTop: -10, width: 870, color: "white" }}>
                <MDBCol
                  className="d-flex justify-content-center "
                  style={{ padding: 3 }}
                  size="12"
                >
                  <div
                    style={{ height: 430, width: 450, zIndex: 6, marginTop: 0 }}
                  >
                    <MDBRow>
                      <MDBCol size="12">
                        <p
                          style={{
                            fontFamily: "PlusJSBold",
                            fontSize: 23,
                            fontWeight: "800",
                            marginTop: 30,
                            marginLeft: 34,
                            lineHeight: 1.2,
                          }}
                        >
                          Log In
                        </p>
                      </MDBCol>

                      <MDBCol
                        className="d-flex justify-content-center"
                        size="12"
                      >
                        <div
                          style={{ width: "380px", marginTop: 8 }}
                          className="form-group"
                        >
                          <input
                            type="text"
                            className="form-control"
                            id="formGroupExampleInput"
                            name="Email"
                            placeholder="Email address"
                            value={this.state.Email}
                            onChange={this.onChange}
                            style={{
                              height: "44px",
                              border: "1.4px solid #d8d9dc",
                              fontFamily: "PlusJSMedium",
                              fontSize: 14,
                              paddingTop: 24,
                              paddingBottom: 24,
                              borderRadius: 0,
                              color: "black",
                              opacity: 1,
                            }}
                            autoComplete="off"
                          />
                        </div>
                      </MDBCol>
                      <MDBCol
                        className="d-flex justify-content-center"
                        size="12"
                      >
                        <div style={{ width: "380px" }} className="form-group">
                          <input
                            type="password"
                            className="form-control"
                            id="formGroupExampleInput"
                            name="Password"
                            placeholder="Password"
                            value={this.state.Password}
                            onChange={this.onChange}
                            style={{
                              height: "44px",
                              border: "1.4px solid #d8d9dc",
                              paddingTop: 24,
                              paddingBottom: 24,
                              borderRadius: 0,
                            }}
                            autoComplete="off"
                          />
                        </div>
                      </MDBCol>

                      <MDBCol
                        className="d-flex justify-content-center "
                        size="12"
                      >
                        <div
                          onClick={(e) => this.onSubmitEmail(e)}
                          className="  HeroButton lightButton"
                          style={{
                            cursor: "pointer",
                            fontSize: 16,
                            width: 380,
                            height: 60,
                            marginLeft: 13.5,
                            marginTop: 0,
                            borderRadius: 0,
                          }}
                        >
                          Log In
                        </div>
                      </MDBCol>
                      <MDBCol
                        className="d-flex justify-content-center "
                        size="12"
                      >
                        {this.state.error ? (
                          <p
                            className="d-inline"
                            style={{
                              fontFamily: "PlusJSRegular",
                              fontSize: 11,
                              marginTop: 12,
                              position: "absolute",
                              color: "red",
                            }}
                          >
                            {this.state.error}
                          </p>
                        ) : null}
                      </MDBCol>
                      <MDBCol
                        className="d-flex justify-content-center "
                        size="12"
                      >
                        <p
                          className="d-inline"
                          style={{
                            fontFamily: "PlusJSRegular",
                            fontSize: 11,
                            marginTop: 40,
                          }}
                        >
                          Having trouble logging in?
                          <a
                            href="mailto:help@youdub.me"
                            className="d-inline"
                            style={{
                              color: "#FF0000",

                              fontWeight: 700,
                            }}
                          >
                            {" "}
                            Get in touch
                          </a>
                        </p>
                      </MDBCol>
                      <MDBCol
                        className="d-flex justify-content-center  "
                        size="12"
                      >
                        <div
                          className=" d-flex justify-content-center  "
                          style={{
                            fontFamily: "PlusJSRegular",
                            backgroundColor: "black",
                            width: 450,
                            marginTop: 30,
                            height: 50,
                          }}
                        >
                          <p
                            className="d-inline"
                            style={{
                              fontFamily: "PlusJSRegular",
                              fontSize: 13,
                              marginTop: 14,
                              color: "white",
                            }}
                          >
                            Don't have an account?{" "}
                            <p
                              className="d-inline"
                              style={{ color: "#EA552B", fontWeight: 700 }}
                            >
                              {" "}
                              <a
                                href=""
                                style={{
                                  color: "white",
                                  fontWeight: 700,
                                  marginLeft: 5,
                                }}
                                exact
                                onClick={() => window.scrollTo(0, 0)}
                              >
                                Book a meeting
                              </a>
                            </p>
                          </p>
                        </div>
                      </MDBCol>

                      <MDBCol
                        className="d-flex HeroSection justify-content-center "
                        size="12"
                      >
                        <p
                          className="d-inline"
                          style={{
                            fontFamily: "PlusJSRegular",
                            fontSize: 11,
                            marginTop: 20,
                          }}
                        >
                          © Copyright 2023 YouDub, LLC
                        </p>
                      </MDBCol>
                    </MDBRow>
                  </div>
                </MDBCol>
              </MDBRow>
            </div>
          </MDBRow>
          {/* <MDBRow style={{ marginTop: 20 }}>
                        <MDBCol size="12">
                            <img src={require("./backgroundImage1.png")} style={{ filter: "blur(1px)", "-webkit-filter": "blur(1px)", height: 300, width: "86%", objectFit: "cover", marginLeft: 80, opacity: 1 }} />
                            <p style={{ fontFamily: "PlusJSMedium", position: "absolute", top: 60, lineHeight: 1.2, fontSize: 30, color: "white", fontWeight: "600", left: 150 }}>The largest & most trusted online <br />community for fetish lovers.</p>
                            <NavLink
                                to="/welcome"
                                exact
                                onClick={() => window.scrollTo(0, 0)}>
                                <div className='d-flex justify-content-center' style={{ cursor: "pointer", height: 45, width: 200, backgroundColor: "white", position: "absolute", top: 160, left: 150, borderRadius: 5 }}>
                                    <p style={{ fontFamily: "PlusJSMedium", fontSize: 14, color: "black", fontWeight: "600", marginTop: 12 }}>GET STARTED</p>


                                </div>
                            </NavLink>



                        </MDBCol>

                    </MDBRow> */}

          {/* 
                    <MDBRow style={{ marginTop: 100, overflowY: "hidden" }}>
                        <MDBCol size="12">
                            <p style={{ fontFamily: "PlusJSMedium", fontSize: 30, fontWeight: "600", marginLeft: 80 }}>Popular Fetish Searches</p>

                        </MDBCol>

                        <MDBCol size="12">
                            <div style={{ height: 200, width: "86%", backgroundColor: "#f8f8f8", marginTop: 10, marginLeft: 80, borderRadius: 0 }}>


                            </div>
                        </MDBCol>


                    </MDBRow> */}
        </MDBCol>
      </>
    );
  }
}

export default withRouter(SignIn);
